import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Provider } from '@angular/core';
import { Router } from '@angular/router';
import { LoadableErrorService } from '@rivethealth/client/common/load/loadable-error.service';
import {
  EncounterFrownyFaceError,
  ViewPage,
} from '@rivethealth/data/analytics/event-types';
import { Observable } from 'rxjs/internal/Observable';
import { Subscription } from 'rxjs/internal/Subscription';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { API_URL } from '../../api/common';
import {
  AnalyticsService,
  routeAnalyticsInitializer,
} from '../../common/analytics/common-analytics.service';
import { ACCOUNT_INITIALIZE } from './account-initalizer';
import { AccountState } from './account.state';

@Injectable()
export class AccountAnalyticsService extends AnalyticsService {
  accountId: Observable<number> = this.accountState.id;
  accountIdSync: number = this.accountState.accountId;

  loadableErrorSubscription: Subscription;

  navigationEvent = ViewPage;

  private readonly userStream = this.events.pipe(
    withLatestFrom(this.accountId),
    filter(([accountId]) => accountId != null),
    mergeMap(([event, accountId]) =>
      this.http
        .post<void>(`${this.apiUrl}/analytics/user-event`, event, {
          params: {
            accountId: accountId.toString(),
          },
        })
        .pipe(
          map(() => {
            return event;
          }),
        ),
    ),
  );

  ngOnDestroy(): void {
    this.loadableErrorSubscription.unsubscribe();
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient,
    router: Router,
    private readonly accountState: AccountState,
    private readonly loadableErrorService: LoadableErrorService,
  ) {
    super(apiUrl, http, router);

    this.loadableErrorSubscription = this.loadableErrorService
      .getComponentNameObservable()
      .subscribe((componentName: string) => {
        if (this.accountIdSync) {
          this.logEvent(EncounterFrownyFaceError, {
            'component name': componentName,
          });
        }
      });

    this.userStream.subscribe(evt => {
      /* eslint-disable no-console */
      console.groupCollapsed(`Analytics: ${evt.name}`);
      console.info('Metadata:');
      console.table(evt.metadata);
      console.info('Client metadata:');
      console.table(evt.client_metadata);
      console.groupEnd();
      /* eslint-enable no-console */
    });
  }
}

export const ACCOUNT_ANALYTICS_PROVIDERS: Provider[] = [
  {
    provide: ACCOUNT_INITIALIZE,
    multi: true,
    useFactory: routeAnalyticsInitializer,
    deps: [AccountAnalyticsService, Router],
  },
];
